import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import styles from './FormAuthors.module.css';

import Title from '../../components/Title';
import InputForm from '../../components/InputForm';
import Button from '../../components/Button';

export default function FormAuthors() {
  const navigate = useNavigate();
  const [author, setAuthor] = useState({
    nome: '',
    nomeArtistico: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    foto: null,
    biografia: '',
    generoLiterario: []
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      let newValues = [...author[name]];
      if (checked) {
        newValues.push(value);
      } else {
        newValues = newValues.filter((item) => item !== value);
      }
      setAuthor({
        ...author,
        [name]: newValues
      });
    } else {
      let newValue = value;
      setAuthor({
        ...author,
        [name]: newValue
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setAuthor({
      ...author,
      foto: file,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!author.foto) {
      alert('Por favor, selecione uma foto do autor');
      return;
    }
    
    const formData = new FormData();
    formData.append('nome', author.nome);
    formData.append('nomeArtistico', author.nomeArtistico);
    formData.append('email', author.email);
    formData.append('senha', author.senha);
    formData.append('confirmarSenha', author.confirmarSenha);
    formData.append('foto', author.foto);
    formData.append('biografia', author.biografia);
    formData.append('generoLiterario', JSON.stringify(author.generoLiterario));

    axios.post('https://back-cultura-sje-production.up.railway.app/create-author', formData, {
      headers: { 
        'Content-Type': 'multipart/form-data' 
      }
    })
      .then(() => {
        setAuthor({
          nome: '',
          nomeArtistico: '',
          email: '',
          senha: '',
          confirmarSenha: '',
          foto: null,
          biografia: '',
          generoLiterario: [],
        });

        alert('Autor cadastrado com sucesso.')

        navigate('/autores/login');
      })
      .catch((error) => {
        console.error('Erro no envio do formulário', error);

        if (error.response && error.response.data && error.response.data.message) {
          const mensagem = error.response.data.message;

          if (mensagem === 'Autor já cadastrado') {
            alert('Este e-mail já está cadastrado.');
          } else if (mensagem === 'A senha deve conter entre 6 a 15 caracteres') {
            alert('A senha deve conter entre 6 e 12 caracteres.');
          } else if (mensagem === 'As senhas não correspondem!') {
            alert('As senhas não correspondem.');
          } else if (mensagem === 'Todos os campos são obrigatórios!') {
            alert('Por favor, preencha todos os campos.');
          } else if (mensagem === 'É obrigatório selecionar pelo menos um gênero literário.') {
            alert('É obrigatório selecionar pelo menos um gênero literário.');
          }
        } else {
          alert('Erro inesperado ao cadastrar. Tente novamente mais tarde.');
        }
      });
    };
      
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <Title color='var(--brown-300)'>Cadastro de Autores</Title>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <div className={styles.inputContainer}>
            <InputForm 
              mode='input'
              type='text'
              name='nome'
              title='Nome'
              placeholder='Digite seu nome'
              value={author.nome}
              onChange={handleChange}
            />
            <InputForm 
              mode='input'
              type='text'
              name='nomeArtistico'
              title='Nome Artístico'
              placeholder='Digite seu nome artístico'
              value={author.nomeArtistico}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputContainer}>
            <InputForm 
              mode='input'
              type='email'
              name='email'
              title='E-mail'
              placeholder='Digite seu e-mail'
              value={author.email}
              onChange={handleChange}
            />
            <InputForm 
              mode='input'
              type='password'
              name='senha'
              title='Senha'
              placeholder='Digite sua senha para login'
              value={author.senha}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputContainer}>
            <InputForm 
              mode='input'
              type='password'
              name='confirmarSenha'
              title='Confirmar senha'
              placeholder='Confirme sua senha'
              value={author.confirmarSenha}
              onChange={handleChange}
            />
            <InputForm 
              mode='input'
              type='file'
              name='foto'
              title='Foto do autor'
              onChange={handleFileChange}
              accept='image/*'
            />
          </div>
            <InputForm 
              mode='textarea'
              name='biografia'
              title='Biografia'
              placeholder='Digite sua sua biografia'
              value={author.biografia}
              onChange={handleChange}
            />
          <InputForm
            mode='checkbox'
            name='generoLiterario'
            title='Gêneros Literários'
            value={author.generoLiterario}
            onChange={handleChange}
            options={[
              { name: 'Romancista', value: 'romancista' },
              { name: 'Cordelista', value: 'cordelista' },
              { name: 'Cronista', value: 'cronista' },
              { name: 'Contista', value: 'contista' },
              { name: 'Poeta/Poetisa', value: 'poeta/poetisa' },
            ]}
          />
          <div className={styles.button}>
            <Button>Enviar</Button>
          </div>
        </form>
      </div>
    </main>
  )
}
